'use client';

import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';

import { getStoreById } from '@libs/api-proxy-client';

export const storeQueryFactory = (storeId?: string) =>
    queryOptions({
        queryKey: ['store', storeId],
        queryFn: storeId ? () => getStoreById(storeId) : skipToken,
        // staleTime – keep cache 10 minutes - data is considered fresh for 10 minutes,
        // and during this period, reusing the cache will not fetch new data.
        staleTime: 10 * 60 * 1000,
    });

export const useStoreQuery = (storeId?: string) => useQuery(storeQueryFactory(storeId));
